export const GET_DICTIONARY_COLUMNS_SUCCESS = 'GET_DICTIONARY_COLUMNS_SUCCESS';
export const ADD_DICTIONARY_COLUMN_REQUEST = 'ADD_DICTIONARY_COLUMN_REQUEST';
export const ADD_DICTIONARY_COLUMN_SUCCESS = 'ADD_DICTIONARY_COLUMN_SUCCESS';
export const ADD_DICTIONARY_COLUMN_ERROR = 'ADD_DICTIONARY_COLUMN_ERROR';
export const UPDATE_DICTIONARY_COLUMN_REQUEST =
  'UPDATE_DICTIONARY_COLUMN_REQUEST';
export const UPDATE_DICTIONARY_COLUMN_SUCCESS =
  'UPDATE_DICTIONARY_COLUMN_SUCCESS';
export const UPDATE_DICTIONARY_COLUMN_ERROR = 'UPDATE_DICTIONARY_COLUMN_ERROR';
export const DELETE_DICTIONARY_COLUMN_REQUEST =
  'DELETE_DICTIONARY_COLUMN_REQUEST';
export const DELETE_DICTIONARY_COLUMN_SUCCESS =
  'DELETE_DICTIONARY_COLUMN_SUCCESS';
export const DELETE_DICTIONARY_COLUMN_ERROR = 'DELETE_DICTIONARY_COLUMN_ERROR';
